import React, { useEffect, useState } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import Spinner from '../components/spinner/Spinner';

import {
  getAuthToken,
  getRefreshToken,
  getUserInformation,
  getAccessToken
} from '../services/TokenHandler';
import LoadingBarTop from '../components/barTop/barTop';

export const ProtectedRoutes = () => {
  const [status, setStatus] = useState(false);
  const [Role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();
  const userInfo = getUserInformation();
  useEffect(() => {
    if (getAccessToken() && getAuthToken() && getRefreshToken() && userInfo) {
      setStatus(true);
      setRole(JSON.parse(userInfo).role.name);
    } else {
      setStatus(false);
    }

    setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => {
      setStatus(false);
    };
  }, [userInfo]);

  if (loading) return <LoadingBarTop />;
  return status ? (
    Role === 'Copa Air User' &&
    !['/web-rtc-dashboard', '/web-rtc', '/cdr-reports'].includes(pathname) ? (
      <Navigate to="/web-rtc-dashboard" />
    ) : pathname === '/' ? (
      <Navigate to="/dashboard" />
    ) : (
      <Outlet />
    )
  ) : (
    <Navigate to="/login" />
  );
};
